const styles = theme => ({
  padding: {
    paddingTop: '1rem'
  },
})

export default styles
